export default __webpack_public_path__ + "assets/img/Delete.8e1f17d5.svg";